import React from 'react'
import { connect } from 'react-redux'
import { 
  Glyphicon,
  Navbar, Nav, NavItem, NavDropdown, MenuItem
} from 'react-bootstrap'

import { saveChanges } from '../lib/MetagnosticDuck/persistence'
import { changeLanguage } from '../actions/ui.js'
import { logOut, alfred } from '../lib/APIClient'
import { getText, getLanguage } from '../lib/text.js'
import { getRateEurYuan, getTimestamp } from "../lib/exchangeRateClient.js"

import IfAllowed from '../components/IfAllowed'

import "./Navigation.less"

const version = require('../../../package.json').version

const Navigation = ({ 
  modalsList, history, isLoggedIn, username, changeLanguage 
}) => (
  <Navbar 
    inverse 
    collapseOnSelect
    className="NavigationNavbar"
    style={{ 
      color: "white",
      borderRadius: 0,
    }}
  >
    <Navbar.Header>
      <Navbar.Brand onClick={() => history.push("/private/home")}>
        Tripmaker v{version.split(".")[0]}<small>.{version.split(".")[1]}.{version.split(".")[2]}</small>
      </Navbar.Brand>
      <Navbar.Toggle />
    </Navbar.Header>

    <Navbar.Collapse>

      { 
        isLoggedIn && (
          <Nav>
            <NavItem eventKey={1} onClick={() => history.push("/private/home")}>{getText("Home")}</NavItem>
            <NavDropdown eventKey={2} title={getText("Administración")} id="admin-dropdown">
              {
                [
                  { ek: 21, path: "/private/blocks",     text: getText("Plantillas"), }, 
                  { ek: 22, path: "/private/expenses",   text: getText("Plantillas de gasto"), }, 
                  { ek: 23, path: "/private/activities", text: getText("Actividades"), }, 
                  { ek: 24, path: "/private/cities",     text: getText("Ciudades"), }, 
                  { ek: 25, path: "/private/suppliers",  text: getText("Proveedores"), }, 
                  { ek: 26, path: "/private/users",      text: getText("Usuarios"), }, 
                  { ek: 27, path: "/private/appDocs",    text: getText("App"), }, 
                  { ek: 28, path: "/private/products",   text: getText("ZhangShang"), }, 
                  // #TODO make /documents dependent on permissions ? 
                  { ek: 29, path: "/private/documents",  text: getText("Documentos y publi"), }, 
                ]
                  .map(({ ek, path, text }) => (
                    <MenuItem key={ek} eventKey={ek} onClick={() => history.push(path)}>
                      {text}
                    </MenuItem>
                  ))
              }
            </NavDropdown>
            <NavItem eventKey={3} onClick={() => history.push("/private/oper")}>{getText("Ventas")}</NavItem>
            <IfAllowed verb="read" collection="reservations">
              <NavItem eventKey={4} onClick={() => history.push("/private/purchases")}>{getText("Compras")}</NavItem>
            </IfAllowed>
            <NavItem eventKey={5} onClick={() => history.push("/private/payments")}>{getText("Pagos")}</NavItem>
            
            { false && <NavItem eventKey={6} onClick={alfred}>👨🏻‍✈️ </NavItem> }
          </Nav>
        )
      }

      <Nav pullRight>
        {
          isLoggedIn && (
            <NavDropdown
              eventKey={0}
              title={`👤  ${username}`}
              onClick={() => { console.log("This button does nothing yet") }}
            >
              <NavItem eventKey={8.1}>1€ = ¥{getRateEurYuan().toFixed(4)}元 <small>(última actualización {getTimestamp()})</small></NavItem>
              <NavItem eventKey={8.2} onClick={() => changeLanguage(getLanguage() == "ch" ? "es" : "ch")}>
                {
                  getLanguage() == "ch"
                    ? <span>Cambiar idioma a 🇪🇸 ES (recomendado)</span>
                    : <span>Cambiar idioma a 🇨🇳 CH (no recomendado)</span>
                }
              </NavItem>
              <NavItem 
                eventKey={4} 
                onClick={() => { 
                  logOut()
                    .then(() => { 
                      window.location.href = ("/login") 
                    })
                    .catch(reason => console.error(reason)) 
                }}  
              >
                <Glyphicon glyph="log-out" /> {getText("Salir")}
              </NavItem>
            </NavDropdown>
          )
        }
      </Nav>

    </Navbar.Collapse>
    
    <div className="modalsCounter">
      {modalsList.length}
      {/* : {modalsList.join(", ")} */}
    </div>
  </Navbar>
)

const mapStateToProps = (state) => ({
  saving: state.persistence.saving, 
  isProduction: state.loginData.isProduction,
  isLoggedIn: !!state.loginData.username,
  username: state.loginData.username,
  language: state.ui.language, 
  modalsList: state.ui.modalsList,
})

const mapDispatchToProps = (dispatch) => ({
  onSave: () => dispatch(saveChanges()),
  changeLanguage: lang => dispatch(changeLanguage(lang)), 
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Navigation)
